<script>
    import { onMount, createEventDispatcher } from 'svelte';
    export let session;
    export let role;
    let isPublishing = false;
    let audioSources = [{deviceId: null, kind: "audioInput", label: "no audio"}];
    let videoSources = [{deviceId: null, kind: "videoInput", label: "no video"}]
    let selectedAudio;
    let selectedVideo;
    let publisherContainer;
    let publisher;
    let audioLevel;
    let meter;
    const dispatch = createEventDispatcher();

    let mediaStream;

    // Get the list of devices and populate the drop down lists
    function populateDeviceSources() {
        console.log('populateDeviceSources');
        OT.getDevices((err, devices) => {
            if (err) {
                alert('getDevices error ' + err.message);
                return;
            }
            audioSources = [...audioSources, ...devices.filter(device => device.kind === 'audioInput')]
            videoSources = [...videoSources, ...devices.filter(device => device.kind === 'videoInput')]
            return;
        });
    }

    onMount (async ()=> {
        // We request access to Microphones and Cameras so we can get the labels
        OT.getUserMedia().then((stream) => {
            console.log('Camera onMount! stream: ', stream);
            mediaStream = stream;
            populateDeviceSources();
            // Stop the tracks so that we stop using this camera and microphone
            // If you don't do this then cycleVideo does not work on some Android devices
            stream.getTracks().forEach(track => track.stop());
        });
        // Get the token to connect to the session

    });

    function setupAudioLevelMeter() {
        // const audioLevel = document.querySelector('#audio-meter');
        // const meter = document.querySelector('#audio-meter meter');
        // audioLevel.style.display = 'block';
        let movingAvg = null;
        publisher.on('audioLevelUpdated', (event) => {
        if (movingAvg === null || movingAvg <= event.audioLevel) {
            movingAvg = event.audioLevel;
        } else {
            movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
        }

        // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
        let logLevel = (Math.log(movingAvg) / Math.LN10) / 1.5 + 1;
        logLevel = Math.min(Math.max(logLevel, 0), 1);
        meter.value = logLevel;
        });
    }


    function startPublishing() {
        console.log('start Publishing');
        publisher = OT.initPublisher('publisher',{
            audioSource: selectedAudio,
            videoSource: selectedVideo,
            width: '1280px',
            height: '720px',
            resolution: '1280x720',
            name: `${role}-camera`
        }, (err) => {
            if(err){
                alert('Publish error ' + err.message);
            } else {
                // setupDeviceSwitching();
                setupAudioLevelMeter();
            }
        });
        // Connect to session
        session.publish(publisher);
        isPublishing = true;
        publisher.on('streamCreated', (event) => {
            console.log('publisher streamCreated! ',event);
            dispatch('streamCreated', {
                sources: {selectedAudio, selectedVideo, name:`${role}-camera`, streamId:publisher.streamId, connection:event.stream.connection}
            })
        });
        publisher.on('destroyed', (event) => {
            console.log('publisher stream Destroyed! ',event);
            dispatch('streamDestroyed', {
                sources: {selectedAudio:null, selectedVideo:null, name:`${role}-camera`}
            })
        });
        // Listen to signals in the session
        session.on("signal", function(event) {
            console.log("Signal sent from connection " + event.from.id);
            console.log("Event Data " + event.data);
            // Process the event.data property, if there is any data.
            switch (event.data) {
                case 'mutePublisher':
                    console.log('mute publisher');
                    publisher.publishAudio(false);
                    break;
                case 'unmutePublisher':
                    console.log('unmute publisher');
                    publisher.publishAudio(true);
                    break;
                default:
                    console.log(`Sorry fam, don't know what ${event.detail.sources.name} is.`);
            }

        });

    }

    function recreatePublisherEl(){
        const publisherEl = document.createElement('div');
        publisherEl.id = "publisher";
        publisherContainer.appendChild(publisherEl);
    }

    function stopPublishing(){
        console.log('stop Publishing!');
        mediaStream.getTracks().forEach(track => {console.log('track: ', track); track.stop()});
        publisher.destroy();
        recreatePublisherEl();
        console.log('mediaStream: ',mediaStream);
        // mediaStream.getTracks().forEach(track => track.stop());
        // OT.getUserMedia().then((stream) => {
        //     console.log('Camera onMount! stream: ', stream)
        //     populateDeviceSources();
        //     // Stop the tracks so that we stop using this camera and microphone
        //     // If you don't do this then cycleVideo does not work on some Android devices
        //     stream.getTracks().forEach(track => track.stop());
        // });


        // populateDeviceSources();
        isPublishing = false;
    }



</script>
<section id="container">
    <div id="media-selector">
        <h1>Camera</h1>
        <label for="audio-source-select">Audio Source:</label>
        <select bind:value={selectedAudio} disabled={isPublishing}>
            {#if audioSources}
                {#each audioSources as audioSource}
                    <option value="{audioSource.deviceId}">{audioSource.label || audioSource.kind }</option>
                {/each}
            {/if}
        </select>
        <br/>
        <div id="audio-meter" bind:this={audioLevel}>
            <label for="audio-meter">Audio Level:</label>
            <meter min="0" max="1" bind:this={meter}></meter>
        </div>
        <label for="video-source-select">Video Source:</label>
        <select bind:value={selectedVideo} disabled={isPublishing}>
            {#if videoSources}
                {#each videoSources as videoSource}
                    <option value="{videoSource.deviceId}">{videoSource.label || videoSource.kind }</option>
                {/each}
            {/if}
        </select>
        {#if isPublishing}
            <button id="stop-stream" type="button" on:click={stopPublishing}>Stop stream</button>
        {:else}
            <button id="publish-btn" type="button" on:click={startPublishing}>Publish</button>
        {/if}
    
    </div>
    <div id="publisher-container" bind:this={publisherContainer}>
        <div id="publisher"></div>
    </div>


</section>

<style>
    label {
        display: inline-block;
    }
    #publisher-container {
        display: none;
    }
</style>